import styled from 'styled-components';
import { lighten } from 'polished';

export const Container = styled.section`
	display: grid;
	grid-template-rows: auto 1fr;
	padding-left: 1.5rem;

	@media (min-width: 60em) {
		padding-left: 0;
	}
`;

export const Filters = styled.div`
	padding: 1.5rem 0;

	@media (min-width: 60em) {
		display: flex;
		flex-direction: row-reverse;
		align-items: center;
		justify-content: space-between;
		padding: 0 1rem 1.5rem 0;
	}
`;

export const SearchContainer = styled.div`
	padding: 1.5rem 0;
	margin-right: 1.5rem;

	@media (min-width: 60em) {
		flex: 1 1 0;
		max-width: 40rem;
		padding: 0;
	}
`;

export const TableWrapper = styled.div`
	overflow-x: hidden;
	padding-right: 1.5rem;
`;

export const TableStyles = styled.div`
	.ant-table {
		box-sizing: border-box;
		margin: 0;
		padding: 0;
		color: ${({ theme }) => theme['white']};
		font-variant: tabular-nums;
		line-height: 1.5715;
		list-style: none;
		font-feature-settings: 'tnum';
		position: relative;
		z-index: 0;
		font-size: 1rem;
		background-color: ${({ theme }) => theme['midnight-base']};

		table {
			width: 100%;
			text-align: left;
			border-collapse: separate;
			border-spacing: 0;
		}
	}

	.ant-table-thead > tr > th,
	.ant-table-tbody > tr > td,
	.ant-table tfoot > tr > th,
	.ant-table tfoot > tr > td {
		position: relative;
		padding: 1rem;
		overflow-wrap: break-word;
	}

	.ant-table-thead > tr > th {
		color: ${({ theme }) => theme['white']};
		font-size: 0.9rem;
		font-weight: 500;
		text-align: left;
		background-color: ${({ theme }) => theme['midnight-lighten-5']};
		border-bottom: 1px solid ${({ theme }) => theme['midnight-lighten-10']};
		transition: background-color 0.3s ease;
	}

	.ant-table-tbody > tr > td {
		border-bottom: 1px solid ${({ theme }) => theme['midnight-lighten-10']};
		transition: background-color 0.3s;
		vertical-align: top;
	}

	.ant-table tfoot > tr > th,
	.ant-table tfoot > tr > td {
		border-bottom: 1px solid ${({ theme }) => theme['midnight-lighten-10']};
	}

	.ant-table-tbody > tr.ant-table-row:hover > td {
		background-color: ${({ theme }) => lighten(0.02, theme['midnight-base'])};
	}

	.ant-table-cell-ellipsis {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		word-break: keep-all;
	}

	.ant-table-sticky-header {
		position: sticky;
		z-index: calc(2 + 1);
	}

	.ant-table-sticky-scroll {
		position: fixed;
		bottom: 0;
		z-index: calc(2 + 1);
		display: flex;
		align-items: center;
		background: ${({ theme }) => theme['midnight-base']};
		border-top: 1px solid ${({ theme }) => theme['midnight-lighten-10']};
		opacity: 0.6;
	}

	.ant-table-sticky-scroll:hover {
		transform-origin: center bottom;
	}

	.ant-table-sticky-scroll-bar {
		height: 8px;
		background-color: rgba(255, 255, 255, 0.35);
		border-radius: 4px;
	}

	.ant-table-sticky-scroll-bar:hover {
		background-color: rgba(255, 255, 255, 0.8);
	}

	.ant-table-sticky-scroll-bar-active {
		background-color: rgba(255, 255, 255, 0.8);
	}

	.ant-table-expanded-row-fixed {
		width: 100% !important;
	}

	.ant-table-tbody > tr > td[colspan] {
		padding: 0;
		padding-bottom: 1px;
	}
`;

export const IconWrapper = styled.div`
	position: relative;
	height: 1.625rem;

	& > svg {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
`;

export const HeavyText = styled.span`
	color: ${({ theme }) => theme['white']};
	font-weight: 500;
`;

export const LightText = styled.span`
	color: ${({ theme }) => theme['silver-base']};
	font-weight: 400;
`;

export const Footer = styled.div`
	display: flex;
	justify-content: flex-end;
	padding: 1.25rem 0;

	button {
		&:not(:last-child) {
			margin-right: 0.75rem;
		}
	}
`;
